module.exports = __webpack_public_path__ + "media/front/ico-pdf-79f20fcc.svg";